import React from 'react';
import { FoodPhoto } from '../FoodPhoto';
export function FoodPhoto3() {
  return <FoodPhoto src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200&q=85" alt="Vibrant grain bowl with fresh vegetables and lean protein" caption="Mediterranean grain bowl with chickpeas, roasted peppers, and feta" data-id="element-222" />;
}